import {
  TableHeaderConfig,
  TableHeaderConfigWithType
} from '../../components/_EOS/Table'
import {
  eInventoryCheckState,
  eTypeInventoryCheck
} from '../../enums/eInventoryCheck'
import { formatNonUTCDate, utcToLocal } from '../../utils/dateHelper'
import { InventoryCheck, InventoryCheckDetail } from './entities/InventoryCheck'

export const generateTableHeadersInventoryCheck = () => {
  const tableHeaders: TableHeaderConfigWithType<InventoryCheck>[] = [
    {
      field: 'inventoryCheckId',
      title: 'ID',
      sortable: true
    },
    {
      field: 'stateId',
      title: 'Estado',
      sortable: false,
      formater: (stateId: unknown) => setState(stateId as number)
    },
    {
      field: 'createdDate',
      title: 'Fecha de Creación',
      sortable: true,
      formater: (createdAt: unknown) =>
        utcToLocal(createdAt as string, 'dd/MM/yyyy')
    },
    {
      field: 'promiseDate',
      title: 'Fecha Compromiso',
      sortable: true,
      formater: (promiseDate) =>
        formatNonUTCDate(promiseDate as string, 'dd/MM/yyyy')
    },
    {
      field: 'totalPosition',
      title: 'Posiciones',
      sortable: false
    },
    {
      field: 'progress',
      title: 'Avance',
      sortable: true,
      formater: (progress: unknown) => formatProgress(progress as number)
    },
    {
      field: 'tag',
      title: 'Tag',
      sortable: false
    }
  ]

  return tableHeaders
}

export const generateTableHeadersInventoryCheckDetail = () => {
  const tableHeaders: TableHeaderConfigWithType<InventoryCheckDetail>[] = [
    {
      field: 'positionName',
      title: 'Posición',
      sortable: false
    },
    {
      field: 'cycle',
      title: 'Ciclo',
      sortable: false
    },
    {
      field: 'userAlias',
      title: 'Usuario',
      sortable: false,
      formater: (userAlias: unknown) => setUser(userAlias)
    },
    {
      field: 'startDate',
      title: 'Fecha de Inicio',
      sortable: false,
      formater: (startDate: unknown) =>
        utcToLocal(startDate as string, 'dd/MM/yyyy')
    },
    {
      field: 'endDate',
      title: 'Fecha de Termino',
      sortable: false,
      formater: (endDate: unknown) =>
        utcToLocal(endDate as string, 'dd/MM/yyyy')
    }
  ]
  return tableHeaders
}

export const inventoryCheckBlogTableHeaderConfig: TableHeaderConfig[] = [
  {
    field: 'createdDate',
    title: 'Fecha',
    formater: (value) => utcToLocal(value, 'dd/MM/yyyy hh:mm:ss')
  },
  {
    field: 'inventoryCheckStateId',
    title: 'Estado',
    formater: (stateId: unknown) => setState(stateId as number)
  },
  { field: 'comments', title: 'Comentarios' },
  { field: 'createdUser', title: 'Usuario' }
]

const setUser = (data: string | unknown) => {
  if (!data) return 'Sin usuario'
  else return data as string
}

const formatProgress = (data: number) => {
  return `${String(data)}%`
}

const setState = (idState: number) => {
  return eInventoryCheckState[idState] || ''
}

const setType = (typeId: number) => {
  return eTypeInventoryCheck[typeId] || ''
}
